import { StyleSheet } from 'aphrodite'

import form from './form'
import ColorBlind from './ColorBlind'

export default {
  form: StyleSheet.create(form),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/Community/Billing/Main/style/index.js